import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';
import { formatViews, sortMovies } from '@/lib/movies';

export default function PopularSection() {
  const top = sortMovies(movies, 'hot').slice(0, 8);

  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full px-4 md:px-8">
        <div className="mb-6">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">热门影视精选</h2>
          <p className="mt-1 text-sm text-foreground-600">根据站内浏览热度整理的榜单，实时反映观众关注焦点</p>
        </div>

        <div className="grid grid-cols-1 gap-3 md:gap-4 lg:grid-cols-2">
          {top.map((movie, i) => (
            <Link
              key={movie.id}
              to={`/detail/${movie.id}`}
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300"
            >
              <span
                className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                  i < 3 ? 'bg-accent-500 text-background-50' : 'bg-secondary-100 text-secondary-800'
                }`}
              >
                {i + 1}
              </span>
              <div className="h-20 w-14 shrink-0 overflow-hidden rounded-md bg-background-200">
                <img
                  src={movie.cover}
                  alt={`${movie.title} 缩略图`}
                  title={`${movie.title} 影视缩略图`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="min-w-0 flex-1">
                <h3 className="line-clamp-1 font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-700 md:text-base">
                  {movie.title}
                </h3>
                <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
                  {movie.type} · {movie.genre} · {movie.region} · {movie.year}
                </p>
                <div className="mt-2 flex items-center gap-3 text-xs text-foreground-600">
                  <span className="flex items-center gap-1 text-accent-600">
                    <i className="ri-fire-line"></i>
                    {formatViews(movie.views)}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-timer-line"></i>
                    {movie.duration}
                  </span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line hidden text-xl text-foreground-300 transition-colors group-hover:text-accent-500 sm:block"></i>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}